export default __webpack_public_path__ + "static/media/seduction.c18017c4.png";